import InstantMessagePresenceType from 'owa-service/lib/contract/InstantMessagePresenceType';
import instantMessagePresence from 'owa-service/lib/factory/instantMessagePresence';
import setPresenceOperation from 'owa-service/lib/operation/setPresenceOperation';
import ucmaServiceOptioins from './ucmaServiceOptions';

export default function setPresence(presence: InstantMessagePresenceType): Promise<number> {
    return setPresenceOperation(
        {
            presenceSetting: instantMessagePresence({
                Presence: presence,
            }),
        },
        ucmaServiceOptioins
    );
}
